export default __webpack_public_path__ + "static/media/instagram.469cb83e.png";